import { ROUTE } from "../../routes";
import { StoreKey, partnerApi } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
export const goBack = async (action, _datastore, { navigate }) => {
    const currentActiveTabIndex = action?.payload?.currentActiveTabIndex;
    navigate(ROUTE.PARTNER_ACTIVE_CUSTOMER, { currentActiveTabIndex, showDashboardCard: false });
};
export const applyInterestFilterAction = async (action, _datastore, { navigate, network, asyncStorage }) => {
    const mandateSelected = action?.payload?.mandateSelected;
    const interestSelected = action?.payload?.interestSelected;
    const lenderCustomerSelected = action?.payload?.lenderCustomerSelected;
    const searchText = action?.payload?.searchText || '';
    let numberOfFilterApplied = 0;
    if (!interestSelected?.includes('ALL')) {
        numberOfFilterApplied = interestSelected.length;
    }
    if (!mandateSelected?.includes('ALL')) {
        numberOfFilterApplied = numberOfFilterApplied + mandateSelected.length;
    }
    if (!lenderCustomerSelected?.includes('ALL')) {
        numberOfFilterApplied = numberOfFilterApplied + lenderCustomerSelected.length;
    }
    const filterObj = {
        "filter": {
            "interestStatuses": interestSelected?.includes('ALL') ? [] : interestSelected,
            "mandateStatus": mandateSelected?.includes('ALL') ? [] : mandateSelected,
            "lenders": lenderCustomerSelected?.includes('ALL') ? [] : lenderCustomerSelected,
        },
        "searchContent": searchText
    };
    const currentPageCustomer = action?.payload?.currentPage;
    const user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    let partnerAccountId = user?.linkedPartnerAccounts[0].accountId;
    const pageNumber = currentPageCustomer || 1;
    const response = await network.post(`${partnerApi.getAllCustomerList}${partnerAccountId}/partnerdashboard/interestDue/${pageNumber}`, filterObj, {
        headers: await getAppHeader(),
    }, async () => { return; }, { isPartnerPlatform: true });
    if (response.status === 200) {
        await navigate(ROUTE.PARTNER_ACTIVE_CUSTOMER, {
            currentPageCutomerFiltered: response?.data?.currentPage,
            pageSizeCustomerFiltered: response?.data?.actualpageSize,
            actualPageSizeCustomerFiltered: response?.data?.actualpageSize,
            customerDataFiltered: response?.data?.data,
            dataFetched: true,
            currentActiveTabIndex: 1,
            dataFiltered: true,
            showDashboardCard: false,
            totalPagesFiltered: response?.data?.totalPages,
            numberOfFilterApplied,
            filterObj
        });
    }
};
